import {$, w} from './constants';
import { trackEvent } from './gtm';

gsap.registerPlugin(Draggable);

let mediaLoop = null;
let mediaResizeTimer = null;
let mediaOriginalHtml = null;

$(function () {
    const slider = document.querySelector('.home_gbm_media_slider');
    if (!slider) return;

    mediaOriginalHtml = slider.innerHTML;

    initMediaLoop();

    w.on('resize', function () {
        clearTimeout(mediaResizeTimer);
        mediaResizeTimer = setTimeout(rebuildMediaLoop, 600);
    });
});

function rebuildMediaLoop() {
    const slider = document.querySelector('.home_gbm_media_slider');
    if (!slider || !mediaOriginalHtml) return;

    if (mediaLoop) {
        mediaLoop.kill();
        mediaLoop = null;
    }

    slider.innerHTML = mediaOriginalHtml;

    requestAnimationFrame(() => {
        requestAnimationFrame(initMediaLoop);
    });
}

function initMediaLoop() {
    const slider = document.querySelector('.home_gbm_media_slider');
    if (!slider) return;

    const slides = gsap.utils.toArray(slider.querySelectorAll('.home-template__media-slide'));
    if (!slides.length) return;

    equalizeSlideHeights(slides);

    mediaLoop = horizontalLoop(slides, {
        repeat: -1,
        speed: 0.45,
        draggable: true,
        paddingRight: window.innerWidth < 951 ? 10 : 20
    });

    mediaLoop.timeScale(1);

    slides.forEach(slide => {
        slide.addEventListener('mouseenter', () => {
            gsap.to(mediaLoop, { timeScale: 0, duration: 0.25, overwrite: true });
        });

        slide.addEventListener('mouseleave', () => {
            gsap.to(mediaLoop, { timeScale: 1, duration: 0.25, overwrite: true });
        });
    });
}

function equalizeSlideHeights(slides) {
    slides.forEach(slide => {
        slide.style.height = '';
        slide.style.minHeight = '';
    });

    let maxHeight = 0;

    slides.forEach(slide => {
        maxHeight = Math.max(maxHeight, slide.offsetHeight);
    });

    slides.forEach(slide => {
        slide.style.height = `${maxHeight}px`;
        slide.style.minHeight = `${maxHeight}px`;
    });
}

function trackMediaSwipe(slider, direction) {

    const gtmEvent = slider.getAttribute('data-event-gtm');

    if (!gtmEvent || typeof trackEvent !== 'function') return;

    trackEvent(gtmEvent, {
        sliderId: slider.id || '',

        action: 'swipe',
        direction: direction
    });
}

function horizontalLoop(items, config) {
    items = gsap.utils.toArray(items);
    config = config || {};

    let tl = gsap.timeline({
            repeat: config.repeat,
            paused: config.paused,
            defaults: { ease: 'none' },
            onReverseComplete: () => tl.totalTime(tl.rawTime() + tl.duration() * 100)
        }),
        length = items.length,
        startX = items[0].offsetLeft,
        times = [],
        widths = [],
        xPercents = [],
        curIndex = 0,
        pixelsPerSecond = (config.speed || 1) * 100,
        snap = config.snap === false ? v => v : gsap.utils.snap(config.snap || 1),
        totalWidth,
        curX,
        distanceToStart,
        distanceToLoop,
        item,
        i;

    const populateWidths = () => {
        items.forEach((el, i) => {
            widths[i] = parseFloat(gsap.getProperty(el, 'width', 'px'));
            xPercents[i] = snap(
                (parseFloat(gsap.getProperty(el, 'x', 'px')) / widths[i]) * 100 +
                gsap.getProperty(el, 'xPercent')
            );
        });
    };

    const getTotalWidth = () => {
        return (
            items[length - 1].offsetLeft +
            (xPercents[length - 1] / 100) * widths[length - 1] -
            startX +
            items[length - 1].offsetWidth * gsap.getProperty(items[length - 1], 'scaleX') +
            (parseFloat(config.paddingRight) || 0)
        );
    };

    populateWidths();

    gsap.set(items, {
        xPercent: i => xPercents[i]
    });

    gsap.set(items, { x: 0 });

    totalWidth = getTotalWidth();

    for (i = 0; i < length; i++) {
        item = items[i];

        curX = (xPercents[i] / 100) * widths[i];
        distanceToStart = item.offsetLeft + curX - startX;
        distanceToLoop = distanceToStart + widths[i] * gsap.getProperty(item, 'scaleX');

        tl.to(item, {
            xPercent: snap(((curX - distanceToLoop) / widths[i]) * 100),
            duration: distanceToLoop / pixelsPerSecond
        }, 0)
        .fromTo(item, {
            xPercent: snap(((curX - distanceToLoop + totalWidth) / widths[i]) * 100)
        }, {
            xPercent: xPercents[i],
            duration: (curX - distanceToLoop + totalWidth - curX) / pixelsPerSecond,
            immediateRender: false
        }, distanceToLoop / pixelsPerSecond)
        .add('label' + i, distanceToStart / pixelsPerSecond);

        times[i] = distanceToStart / pixelsPerSecond;
    }

    tl.progress(1, true).progress(0, true);

    if (config.draggable && typeof Draggable === 'function') {
        let proxy = document.createElement('div'),
        wrap = gsap.utils.wrap(0, 1),
        ratio,
        startProgress,
        startX,
        lastDirection = null,
        hasDragged = false,
        draggable,
        trigger = items[0].parentNode,
        align = () => {
            tl.progress(wrap(startProgress + (draggable.startX - draggable.x) * ratio));
        };

        draggable = Draggable.create(proxy, {
            trigger: trigger,
            type: 'x',

            onPress() {
                startProgress = tl.progress();
                startX = this.x;
                lastDirection = null;
                hasDragged = false;

                tl.progress(0);
                populateWidths();
                totalWidth = getTotalWidth();
                ratio = 1 / totalWidth;
                tl.progress(startProgress);

                gsap.to(tl, { timeScale: 0, duration: 0.2, overwrite: true });
            },

            onDrag() {
                hasDragged = true;

                const direction = this.x < startX ? 'right' : 'left';

                if (direction !== lastDirection) {
                    lastDirection = direction;
                }

                align();
            },

            onRelease() {
                if (hasDragged && lastDirection) {
                    trackMediaSwipe(trigger, lastDirection);
                }

                gsap.to(tl, { timeScale: 1, duration: 0.35, overwrite: true });
            }
        })[0];

        tl.draggable = draggable;
    }

    return tl;
}